import { useState, useEffect } from 'react';

/**
 * Custom hook to manage countdown timers for match locks
 * @param {Array} matches - Array of match objects
 * @returns {Object} Object mapping match IDs to countdown strings
 */
export const useMatchTimers = (matches) => {
  const [timeUntilLock, setTimeUntilLock] = useState({});

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const newTimeUntilLock = {};

      matches.forEach((match) => {
        const kickoff = new Date(match.scheduledTime);
        const diff = kickoff - now;

        if (diff > 0) {
          const days = Math.floor(diff / (1000 * 60 * 60 * 24));
          const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((diff % (1000 * 60)) / 1000);

          // Format: show only the 2 most significant units
          if (days > 0) {
            newTimeUntilLock[match.id] = `${days}d ${hours}h`;
          } else if (hours > 0) {
            newTimeUntilLock[match.id] = `${hours}h ${minutes}m`;
          } else {
            newTimeUntilLock[match.id] = `${minutes}m ${seconds}s`;
          }
        } else {
          newTimeUntilLock[match.id] = 'LOCKED';
        }
      });

      setTimeUntilLock(newTimeUntilLock);
    }, 1000);

    return () => clearInterval(interval);
  }, [matches]);

  return timeUntilLock;
};
